module.exports = __webpack_public_path__ + "static/media/our-partners-first-right@2x.56125b00.jpg";